import loadingBook from "../../assets/loading_book.gif";

const LoadingPage = () => {
  return (
    <div className=" flex justify-center items-center h-screen bg-white">
      <img className=" w-24 h-24 lg:w-40 lg:h-40" src={loadingBook} alt="" />
    </div>
  );
};

export default LoadingPage;
